import { Component, ViewChild, ElementRef, Input, AfterViewInit, PLATFORM_ID, DOCUMENT } from '@angular/core'
import player from './player'
import {environment} from '../../../../environments/environment'
import { Inject, Injectable } from '@angular/core'

import {isPlatformBrowser} from '@angular/common'
import { BehaviorSubject } from 'rxjs'
import { NGXLogger } from 'ngx-logger'
import { SharedDataService } from 'src/app/core/services/shared-data.service'


@Component({
    selector: 'app-video-player',
    templateUrl: './video-player.component.html',
    styleUrls: ['./video-player.component.scss'],
    standalone: false
})
export class VideoPlayerComponent implements AfterViewInit {
  @ViewChild('fillBar', { static: true }) fillBar: ElementRef
  @ViewChild('video', { static: true }) video: ElementRef
  equipmentProviderInActive: boolean;
  cdn: string;
  // cdn: string = environment.API_CDN_URL
  constructor(
    public logger: NGXLogger,
    public sharedDataService: SharedDataService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: any) {
      this.equipmentProviderInActive = this.sharedDataService.getPortalType();
      if(this.equipmentProviderInActive){
        this.cdn = environment.API_EQUIP_PROVIDER_CDN_URL
      } else {
        this.cdn = environment.API_DENTAL_CDN_URL
      }

   }

  @Input() content: any
  @Input() preview_image: any
  @Input() isDisabled = false
  @Input() modalVideo = false
  @Input() isArticle = false
  @Input() poster = null

  isPlaying = false
  currentTime: any = '0'
  duration: any = '0'
  playImg = 'https://cdn.icreditworks.com/tp/assets/images/play.png'
  player: HTMLVideoElement
  timeline: HTMLElement
  playPauseVideo() {
    if (this.isDisabled === false) { player.playPauseVideo(this) }
  }

  setFullscreenVideo(){
    this.player.requestFullscreen()
  }

  setTime(e) {
    player.setTime(this, e)
  }

  ngAfterViewInit() {
    if (!this.isDisabled && isPlatformBrowser(this.platformId)) {
      this.afterLoadedMetadata()
    }
  }

  afterLoadedMetadata() {
      if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    if (this.isArticle) {
      setTimeout(() => {
        this.player.src = this.content.url
        this.duration = this.player.duration
      })
      this.logger.info(this.video)
      this.logger.info(this.player)
      this.player = this.video.nativeElement as HTMLVideoElement
      this.timeline = this.document.querySelector('#timeline') as HTMLElement
      this.player.load()
    }
    else {
      setTimeout(() => {
        this.duration = this.player.duration
        if (this.content.video.data?.attributes.url.startsWith('http')) {
          this.player.src = this.content.video.data.attributes.url
        }
        else {
          this.player.src = this.content.video.data.attributes.url
        }
      })
      this.player = this.video.nativeElement as HTMLVideoElement
      this.timeline = this.document.querySelector('#timeline') as HTMLElement
      this.player.load()
    }
  }

  changeDuration(){
    this.currentTime = this.player.currentTime
    this.duration = String(this.player.duration - this.player.currentTime)
    const position = this.player.currentTime / this.player.duration
    this.timeline.style.width = position * 100 + '%'
  }
}
